import React, { useState, useEffect, useMemo } from 'react';
import { convertiDataComputer2Umano, oggiData } from './funzioni.js'
import SelezionaData from './SelezionaData';
import Clessidra from '../Pagine/Clessidra'
import Tendina2 from './Tendina2';
import stile from './stile.module.css';
import IconaMenu from './IconaMenu';
import { haPersonalizzazione } from '../funzioni.js';
import PrenotazioneCorsiOggi from './PrenotazioniCorsiOggi.js'

function PrenotazioniElencoIscritto(props) {
    const PAGINE = {
        "caricamentoDati": 1,
        "impostaFiltri": 2,
        "creaReport": 3,
        "visualizzaReport": 4,
        "vaiGiorno": 5
    };
    const iconaPrenotaPerCorso = require('./prenotapercorso.png');
    const iconaPrenotaPerGiorno = require('./prenotapergiorno.png');
    const [pagina, setPagina] = useState(PAGINE.caricamentoDati);
    const [datiReport, setDatiReport] = useState([]);
    const [datiListeAttesa, setDatiListeAttesa] = useState([]);
    const [giorno, setGiorno] = useState("");

    var oggetto = "corso";
    if (haPersonalizzazione(props.identitaSelezionata, "prenotazioni_campo")) oggetto = "campo";

    function elimina(oggetto, idCorso, dataInizio, dataFine) {
        var op = "";
        if (oggetto==="prenotazione") op = "prenotazioneCorsiCanc";
        if (oggetto==="lista_attesa") op = "listeAttesaCanc";
        if (op === "") return;

        const requestOptions = {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ 
            op:op, 
            idCorso:idCorso, 
            idPersona:props.identitaSelezionata.idpersona, 
            dataInizio:dataInizio, 
            dataFine:dataFine, 
            note: "", 
            emak: props.emak, 
            sessionId: props.sessionId 
          })
        };
        fetch(props.UrlBackend, requestOptions)
        .then(risposta => risposta.json())
        .then(
          (valoreRitorno) => {
            if (valoreRitorno.verifvers===0) {
              // necessario aggiornare la app
              props.callbackAggiornaApp();
              return;
            }
            if (valoreRitorno.risultatoOperazione === 2) { props.callback(props.PAGINECLIENTI.login); return; }        
            if (valoreRitorno.risultatoOperazione==1) {
              if (oggetto==="prenotazione") window.alert("Prenotazione eliminata");
              if (oggetto==="lista_attesa") window.alert("Uscita ok dalla lista di attesa");
            } else {
              if (valoreRitorno.mess === "Prenotazione non eliminabile in quanto oramai entrata nel periodo di disdetta non consentito") {
                window.alert("IMPOSSIBILE ELIMINARE: non è possibile disdire prenotazioni a meno di " + valoreRitorno.stringa_tempo_annullamento + " da adesso");
              } else {
                window.alert(valoreRitorno.mess);
              }
            }
            setPagina(PAGINE.creaReport);
            ottieniElencoPrenotazioni();
          },
          (error) => { 
            props.callback(props.PAGINECLIENTI.login);
            return; // QUI VA GESTITO COSA FARE NEL FRONTEND SE BACKEND DICE ERRORE
          }
        )
        .catch(function(error) {
          props.callback(props.PAGINECLIENTI.login);
          return;
        });  
    }

    function formattaDataConGiorno(dataStr) {
        const data = new Date(dataStr);
        // se vuoi anche l'anno, aggiungi year: "numeric" dopo day e month
        return new Intl.DateTimeFormat("it-IT", {
            weekday: "long",
            day: "numeric",
            month: "long",
        }).format(data);
    }
    
    function formattaOra(dataStr) {
        const data = new Date(dataStr);
        return new Intl.DateTimeFormat("it-IT", {
            hour: "2-digit",
            minute: "2-digit",
        }).format(data);
    }

    function Report({ datiReport }) {
        // Ordina i dati in base a DATA_INIZIO
        const datiOrdinati = [...datiReport].sort((a, b) =>
            new Date(a.DATA_INIZIO) - new Date(b.DATA_INIZIO)
        );

        const listeOrdinate = [...datiListeAttesa].sort((a, b) =>
            new Date(a.DATA_INIZIO) - new Date(b.DATA_INIZIO)
        );

        return (
            <>
            {datiOrdinati.map((elemento, indice) => {
                const stessaData = elemento.DATA_INIZIO.slice(0, 10) === elemento.DATA_FINE.slice(0, 10);
                const dataFormattata = formattaDataConGiorno(elemento.DATA_INIZIO);
                const oraInizio = formattaOra(elemento.DATA_INIZIO);
                const oraFine = formattaOra(elemento.DATA_FINE);

                return (
                    <div key={indice} style={{ marginBottom: "1em", border: "1px solid #ccc", borderRadius: "5px" }}>
                        <div
                            style={{
                                fontWeight: "bold",
                                background: "#eee",
                                padding: "0.5em",
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                            }}
                        >
                            <div>
                                <span style={{color:"#0000FF"}}>
                                    {elemento.DESCRIZIONE}
                                    {elemento.NOTE=="doppio" && " (doppio)"}
                                </span>
                                <br/>
                                {stessaData
                                    ? <>{dataFormattata}<br/>dalle {oraInizio} alle {oraFine}</>
                                    : <>{formattaDataConGiorno(elemento.DATA_INIZIO)} {oraInizio}<br/>{formattaDataConGiorno(elemento.DATA_FINE)} {oraFine}</>
                                }
                                {elemento.NOTE && <div style={{fontWeight:"normal"}}>{elemento.NOTE}</div>}
                            </div>
                            {!haPersonalizzazione(props.identitaSelezionata, "prenotazioni_iscritti_readonly") &&
                                <button
                                    className={[stile.baRosso, stile.baNormale].join(" ")}
                                    onClick={() => {if (window.confirm(`Confermi eliminazione della prenotazione ${elemento.DESCRIZIONE}?`)) elimina("prenotazione", elemento.ID_CORSO, elemento.DATA_INIZIO, elemento.DATA_FINE)}}
                                >
                                    Elimina
                                </button>
                            }
                        </div>
                    </div>
                );
            })}

            {haPersonalizzazione(props.identitaSelezionata, "liste_attesa") && listeOrdinate.length > 0 &&
                <>
                    {listeOrdinate.map((elemento, indice) => {
                        const stessaData = elemento.DATA_INIZIO.slice(0, 10) === elemento.DATA_FINE.slice(0, 10);
                        const dataFormattata = formattaDataConGiorno(elemento.DATA_INIZIO);
                        const oraInizio = formattaOra(elemento.DATA_INIZIO);
                        const oraFine = formattaOra(elemento.DATA_FINE);

                        return (                    
                            <div key={indice} style={{ marginBottom: "1em", border: "1px solid #aca717", borderRadius: "5px" }}>
                                <div
                                    style={{
                                        fontWeight: "bold",
                                        background: "#f2f1be",
                                        padding: "0.5em",
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                    }}
                                >
                                    <div>
                                        <span style={{color:"#0000FF"}}>in lista di attesa per {elemento.NOMECORSO}</span>
                                        <br/>
                                        {stessaData
                                            ? <>{dataFormattata}<br/>dalle {oraInizio} alle {oraFine}</>
                                            : <>{formattaDataConGiorno(elemento.DATA_INIZIO)} {oraInizio}<br/>{formattaDataConGiorno(elemento.DATA_FINE)} {oraFine}</>
                                        }
                                    </div>

                                    <button
                                        className={[stile.baVerde, stile.baNormale].join(" ")}
                                        onClick={() => {setGiorno(elemento.DATA_INIZIO.split("T")[0]); setPagina(PAGINE.vaiGiorno)}}
                                    >
                                        Giorno
                                    </button>

                                    {!haPersonalizzazione(props.identitaSelezionata, "prenotazioni_iscritti_readonly") &&
                                        <button
                                            className={[stile.baRosso, stile.baNormale].join(" ")}
                                            onClick={() => {if (window.confirm(`Confermi di voler uscire dalla lista di attesa ${elemento.DESCRIZIONE}?`)) elimina("lista_attesa", elemento.ID_CORSO, elemento.DATA_INIZIO, elemento.DATA_FINE)}}
                                        >
                                            Elimina
                                        </button>
                                    }
                                </div>
                            </div>
                        );
                    })} 
                </>
            }           
        </>
        );
    }

    function ottieniElencoPrenotazioni(){
        const oggi = oggiData();
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({op:"reportElencoPrenotazioni",
            emak: props.emak,
            idPersona: props.identitaSelezionata.idpersona,
            dataInizio:oggi,
            sessionId:props.sessionId})
        };
    
        fetch(props.UrlBackend, requestOptions)
            .then(risposta => risposta.json())
            .then(
            (valoreDiRitorno) => {
                if(valoreDiRitorno.risultatoOperazione===2) { props.callback(props.PAGINECLIENTI.login); return; }
                if(valoreDiRitorno.risultatoOperazione===1){
                    setDatiReport(valoreDiRitorno.risultatoRitorno);

                    if (haPersonalizzazione(props.identitaSelezionata, "liste_attesa")) {
                        ottieniElencoListeAttesa();
                    } else {                    
                        setPagina(PAGINE.visualizzaReport);
                    }
                }
                if(valoreDiRitorno.risultatoOperazione===0){
                    alert("Operazione fallita. Se il problema persiste, contattare l'assistenza tecnica");
                    props.callback(props.PAGINECLIENTI.home);
                }                
            },
            (error) => {props.callback(props.PAGINECLIENTI.login);}
            );
    }

    function ottieniElencoListeAttesa(){
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({op:"elencoListeAttesa",
            emak: props.emak,
            idPersona: props.identitaSelezionata.idpersona,
            sessionId:props.sessionId})
        };
    
        fetch(props.UrlBackend, requestOptions)
            .then(risposta => risposta.json())
            .then(
            (valoreDiRitorno) => {
                if(valoreDiRitorno.risultatoOperazione===2) { props.callback(props.PAGINECLIENTI.login); return; }
                if(valoreDiRitorno.risultatoOperazione===1){
                    setDatiListeAttesa(valoreDiRitorno.risultatoRitorno);
                    setPagina(PAGINE.visualizzaReport);
                }
                if(valoreDiRitorno.risultatoOperazione===0){
                    alert("Operazione fallita. Se il problema persiste, contattare l'assistenza tecnica");
                    props.callback(props.PAGINECLIENTI.home);
                }                
            },
            (error) => {props.callback(props.PAGINECLIENTI.login);}
            );
    }

    useEffect(() => {
        setPagina(PAGINE.creaReport);
        ottieniElencoPrenotazioni();
    }, [])
    
    // gestione del tasto BACK
    useEffect(() => {
        if (props.flagRichiestaBack) {
            props.setFlagRichiestaBack(false);
            props.callback(props.PAGINECLIENTI.home);
        } 
    }, [props.flagRichiestaBack])  

    if (pagina === PAGINE.caricamentoDati || pagina === PAGINE.creaReport) {
        return (<Clessidra loading={true} />)
    }

    if (pagina === PAGINE.visualizzaReport) {
        return (
            <div className={stile.contenitorePrincipale} style={{ display: "flex", flexDirection: "column", height: "100%", overflowY: "auto", padding:10 }}>
                {datiReport.length==0 && datiListeAttesa.length==0 ?
                <>
                    <div style={{paddintTop:5, paddingBottom:5, textAlign: "center", fontSize:20}}>Non hai effettuato nessuna prenotazione</div>                    
                </>
                :
                    <Report datiReport={datiReport} />
                }
                {!haPersonalizzazione(props.identitaSelezionata, "prenotazioni_iscritti_readonly") &&
                    <div style={{display:"flex", flexDirection:"row", justifyContent:"center"}}>
                        <IconaMenu
                            callback={() => {
                                if (haPersonalizzazione(props.identitaSelezionata, "prenotazioni_certificato_medico") && props.identitaSelezionata.cert_medico_scaduto == 1) {
                                    alert("Verifica la validità del certificato medico per poter prenotare");
                                    return;
                                }
                                props.callback(props.PAGINECLIENTI.prenotazioni)
                            }}
                            immagine={iconaPrenotaPerCorso}
                            testo={"Prenota\nper "+oggetto}
                        />
                        <IconaMenu
                            callback={() => {
                                if (haPersonalizzazione(props.identitaSelezionata, "prenotazioni_certificato_medico") && props.identitaSelezionata.cert_medico_scaduto == 1) {
                                    alert("Verifica la validità del certificato medico per poter prenotare");
                                    return;
                                }
                                props.callback(props.PAGINECLIENTI.prenotazioniCorsiOggi)
                            }}
                            immagine={iconaPrenotaPerGiorno}
                            testo={"Prenota\nper giorno"}
                        />                
                    </div>
                }
            </div>
        )
    }

    if (pagina === PAGINE.vaiGiorno) {
        return (
            <PrenotazioneCorsiOggi {...props} giorno={giorno}/>
        )
    }

    return (
        <div>Errore pagina non trovata: (PrenotazioniElencoIscritto)</div>
    )
}

export default PrenotazioniElencoIscritto;
